// Company contact details, kept out of the page as plain text.
//
// They're stored in pieces and only assembled when a visitor clicks
// "Send Email" / "Call Now", so the address and number never appear in the
// rendered HTML and aren't matched by simple email/phone scrapers.
// (Not a hard secret — anyone who clicks sees them — just scraper-resistant.)

const EMAIL_PARTS = ['info', 'deckfortech', 'com'];
const PHONE_PARTS = ['91', '90614', '27819'];

export const getEmail = () => `${EMAIL_PARTS[0]}@${EMAIL_PARTS[1]}.${EMAIL_PARTS[2]}`;

// Human-readable, e.g. "+91 90614 27819"
export const getPhoneDisplay = () => `+${PHONE_PARTS.join(' ')}`;

// WhatsApp click-to-chat link with a pre-filled message. The visitor's
// WhatsApp (app or web) opens addressed to us; they just tap send.
export const getWhatsAppLink = (message) =>
  `https://wa.me/${PHONE_PARTS.join('')}?text=${encodeURIComponent(message)}`;

// Dialable, e.g. "+919061427819"
export const getPhoneHref = () => `+${PHONE_PARTS.join('')}`;
